var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 50,
    viewBox: "0 0 55 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 19,
    fill: "#4DADF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2482 19.4286H31.1053C31.266 19.4286 31.391 19.3036 31.391 19.1429V18.5714C31.391 18.4107 31.266 18.2857 31.1053 18.2857H17.9625C17.8018 18.2857 17.6768 18.4107 17.6768 18.5714V19.1429C17.6768 19.3036 17.8018 19.4286 17.9625 19.4286H18.8196C18.8196 22.7321 20.4 25.125 22.15 26.2857C20.4 27.4464 18.8196 29.8393 18.8196 33.1429H17.9625C17.8018 33.1429 17.6768 33.2679 17.6768 33.4286V34C17.6768 34.1607 17.8018 34.2857 17.9625 34.2857H31.1053C31.266 34.2857 31.391 34.1607 31.391 34V33.4286C31.391 33.2679 31.266 33.1429 31.1053 33.1429H30.2482C30.2482 29.8393 28.6678 27.4464 26.9178 26.2857C28.6678 25.125 30.2482 22.7321 30.2482 19.4286ZM29.1053 19.4286C29.1053 20.7321 28.8107 21.8839 28.3464 22.8571H20.7214C20.2571 21.8839 19.9625 20.7321 19.9625 19.4286H29.1053ZM28.5964 30.2857H20.4714C21.1321 28.5625 22.3196 27.3393 23.5071 26.8571H25.5607C26.7482 27.3393 27.9357 28.5625 28.5964 30.2857Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.2a1cd682c6da53651e4e975599fe9b5f.svg";
export { ForwardRef as ReactComponent };